import axios from 'axios'

export default class {

    async getToken(user) {
        const {data} = await axios({
            method: 'POST',
            url: '/auth/token',
            data: user
        })
        return data
    }

    async setTokenExpired(token, refreshToken) {
        await axios({
            method: 'POST',
            url: '/auth/token/revoke',
            data: {
                token: token,
                refresh_token: refreshToken
            }
        })
    }

    async refreshToken(token, refreshToken, forceUpdate = false) {
        const {data} = await axios({
            method: 'POST',
            url: '/auth/token/refresh',
            data: {
                token: token,
                refresh_token: refreshToken,
                forceUpdate: forceUpdate
            },
            useAuth: false
        })
        return data
    }
    
}